import Swiper, {Parallax, Mousewheel, Controller, Pagination, Scrollbar, Navigation, Autoplay} from 'swiper';

Swiper.use([Parallax, Mousewheel, Controller, Pagination, Scrollbar, Navigation, Autoplay]);
import {Fancybox} from "@fancyapps/ui";

import './modules/Form';
import './modules/CookiePolicy';
import './modules/Geo';
import './modules/ContactsMap';
import './modules/CatalogSimilar';
import './modules/CatalogPagination';
import './modules/AsideFloat';
import './modules/Faq';
import './modules/EmailLink';
import {lazyLoad} from './modules/Utils';

document.addEventListener('DOMContentLoaded', () => {
    lazyLoad();
    const swiperIMG = new Swiper('.main-pict', {
        loop: true,
        speed: 2400,
        autoplay: {
            delay: 15000,
            pauseOnMouseEnter: false,
            disableOnInteraction: false,
        },
        parallax: true,
        mousewheel: true,
        pagination: {
            el: '.dots',
            clickable: true
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
    });

    const swiperText = new Swiper('.text-title', {
        loop: true,
        speed: 2700,
        parallax: true,
        mousewheel: true,
    });

    swiperIMG.controller.control = swiperText;
    swiperText.controller.control = swiperIMG;


    let burger = document.querySelector('.burger-block'),
        mobileMenu = document.querySelector('.mobile-menu');

    burger.onclick = function () {
        mobileMenu.classList.toggle('active');
        this.classList.toggle('active-burger');
    }

    // const sideMenuTitle = document.querySelectorAll('.side-menu-title'),
    //     menuArrow = document.querySelectorAll('.menu-arrow');
    //
    // for (let i = 0; i < sideMenuTitle.length; i++) {
    //     sideMenuTitle[i].addEventListener('click', (e) => {
    //         sideMenuTitle.forEach(item => {
    //             item.classList.remove('title-active');
    //         });
    //         menuArrow.forEach(item => {
    //             item.classList.remove('menu-arrow-active');
    //         });
    //         menuArrow[i].classList.add('menu-arrow-active');
    //         sideMenuTitle[i].classList.add('title-active');
    //     });
    // };
});
